import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArrowLeftIcon from 'assets/icons/longArrowLeft.svg';
import useModifiers from 'hooks/useModifiers';

export enum HeaderModifier {
  NO_MARGIN = 'noMargin',
  SMALL_MARGIN = 'smallMargin',
  H1 = 'h1',
  INVERTED = 'inverted',
  OLD = 'old',
  OLD_MARGIN = 'oldMargin',
  OUTLINE = 'outline',
  ONLY_TITLE_MARGIN = 'onlyTitleMargin',
}

export interface HeaderProps {
  title?: string;
  headline: string;
  desc?: string;
  desc2?: string;
  logoUrl?: string;
  backLink?: boolean;
  modifiers?: HeaderModifier[];
}

function Header(props: HeaderProps) {
  const { t } = useTranslation();
  const mods = useModifiers(props.modifiers);

  return (
    <div className={`ct_header ${mods}`}>
      {props.backLink && (
        <div className="ct_header-nav">
          <Link to="/" className="ct_link _nav">
            <ArrowLeftIcon />
            {t('Back', { ns: 'partner' })}
          </Link>
        </div>
      )}
      {!!props.title && (
        <div className="ct_header-title">
          <h2 className="ct_subtitle1">{props.title}</h2>
        </div>
      )}
      <div className="ct_header-content">
        <div className="ct_header-desc">
          <h1 className={`ct_header-headline ${mods.includes(HeaderModifier.H1) ? 'ct_h1' : 'ct_h2'}`}>{props.headline}</h1>
          {props.desc && props.desc.length && (
            <p className="ct_header-text ct_body2">{props.desc}</p>
          )}
          {props.desc2 && props.desc2.length && (
            <p className="ct_header-text ct_body2" style={{ marginTop: (props.desc && props.desc.length) ? '0px' : 'inherit' }}>{props.desc2}</p>
          )}
        </div>
        {props.logoUrl && (
          <div className="ct_header-logo">
            <img src={props.logoUrl} alt={props.headline} />
          </div>
        )}
      </div>
    </div>
  );
}

Header.defaultProps = { ...{} };

export default Header;
